import FbIcon from "./icons/domino/fb_icon";
import React from "react";
import PlIcon from "./icons/pl_icon";

import {p0, p1, p2, p4, p8, p16, p32} from "./pl_commons";
import {useDrop} from "react-dnd";

const Emptyitem = ({item, mod}) => {

    var xpos = parseInt(item.x) * p1;
    var ypos = parseInt(item.y) * p1;

    if (!xpos)
        xpos = 0;
    if (!ypos)
        ypos = 0;

    const [{canDrop, isOver}, drop] = useDrop(() => ({
        accept: 'planitem',
        drop: () => ({
            id: `empty_${mod}_${item.x}_${item.y}`,
            type: `empty`,
            x: item.x,
            y: item.y,
            module: mod,
        }),
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()


            console.log("empty END")
            console.log(item)
            console.log(dropResult)


        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop()
        })
    }))

    let style = {
        border: (isOver && canDrop) ? '1px solid green':null,
        opacity: canDrop?0.3:1.0,
    }

    return (
        <div
            ref={drop}
            style={{
                top: ypos,
                left: xpos,
                width: p1,
                height: p1,
                position: "absolute",
                zIndex: 2,
                ...style,
            }}>
            <PlIcon transform={undefined}>
            </PlIcon>
        </div>
    )

}

export default Emptyitem
